import { useState } from 'react';
import { Button } from '@chakra-ui/react';

import {
  CheckboxOptionsWithConfirm,
  InputWithConfirm,
  TextareaWithConfirm,
  AutocompleteInputWithConfirm,
  RadioOptionsWithConfirm,
  SubHeading,
} from 'shared-components';
import { universities } from 'shared-components';
import { savePreCasInterview } from '../../../../store/student/actions';
import { createUpdatePCIFieldAction } from '../../../../store/student/preCasInterview/actions';
import { Pages } from '../../../../store/student/preCasInterview/types';

import QuestionPage from '../../../templates/question';
import { Q } from '../../../../store/student/types';
import { useDispatch } from 'react-redux';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';

export interface IProps {
  complete: boolean;
  currentStep: number;
  steps: number;
  campus: string;
  considerOtherUni?: boolean;
  otherUni1: string;
  otherUni2: string;
  selectedResearchMethods: string[];
  selectedResearchMethodsOther: string;
  whyNotOtherUni: string;
  considerOtherCourses?: boolean;
  considerOtherCourse: string;
  whyNotConsiderOtherCourse: string;
  courseAlignFutureCareer?: boolean;
  courseAlignFutureCareerOther: string;
  pageConfig: any;
}

type Props = IProps;

const InterviewQPage2 = (props: Props) => {
  const [state, setState] = useState({
    campusError: '',
    otherUni1Error: '',
    otherUni2Error: '',
    howResearchError: '',
    university1Suggestions: [],
    university2Suggestions: [],
    researchMethodError: '',
    selectedResearchMethodsOtherError: '',
    whyNotOtherUniError: '',
    considerOtherCoursesError: '',
    considerOtherCourseError: '',
    whyNotConsiderOtherCourseError: '',
    courseAlignFutureCareerError: '',
    courseAlignFutureCareerOtherError: '',
  });

  const dispatch = useDispatch();
  const onNext = () => {
    dispatch(savePreCasInterview(Pages.PAGE2));
  };
  const onChange = (fieldName: string, value: any, refValue?: any) =>
    dispatch(createUpdatePCIFieldAction(fieldName, value, refValue));

  const { navigateToStudentDashboard } = useCustomNavigate();
  const onBackToTaskList = () => navigateToStudentDashboard();

  // const {
  //   campusError,
  //   otherUni1Error,
  //   otherUni2Error,
  //   university1Suggestions,
  //   university2Suggestions,
  //   researchMethodError,
  //   selectedResearchMethodsOtherError,
  //   whyNotOtherUniError,
  //   considerOtherCoursesError,
  //   considerOtherCourseError,
  //   whyNotConsiderOtherCourseError,
  //   courseAlignFutureCareerError,
  //   courseAlignFutureCareerOtherError
  // } = state;

  const {
    campus,
    considerOtherUni,
    otherUni1,
    otherUni2,
    selectedResearchMethods,
    selectedResearchMethodsOther,
    whyNotOtherUni,
    considerOtherCourses,
    considerOtherCourse,
    whyNotConsiderOtherCourse,
    courseAlignFutureCareer,
    courseAlignFutureCareerOther,
  } = props;

  const onUniversityChange = (evt, suggestionStateName, stateName) => {
    const value = evt.currentTarget.value || '';
    const suggestions = universities.filter(uni => uni.toLowerCase().includes(value.toLowerCase()));

    setState(prevState => ({
      ...prevState,
      [suggestionStateName]: suggestions.slice(0),
    }));
    onChange(stateName, value);
  };

  const onBlurOtherUni = (event, stateName) => {
    const value = (event && event.currentTarget && event.currentTarget.value.trim()) || '';
    const hasFoundOtherUni = universities.filter(uni => uni.toLowerCase().includes(value.toLowerCase())).length > 0;
    const otherUni1Error = hasFoundOtherUni ? '' : 'Please select a university';
    setState({
      ...state,
      otherUni1Error,
    });
    onChange(stateName, value);
  };

  const onFocusOtherUni = (_event, stateName) => {
    setState(prevState => {
      if (prevState[stateName] !== '') {
        return {
          ...prevState,
          [stateName]: '',
        };
      }
      return prevState;
    });
  };

  const getResearchMethods = () => {
    const researchMethods = [
      'University website',
      'University prospectus',
      'Someone I trust recommended it',
      'An agent or representative told me about the university',
      'Other',
    ];

    return researchMethods.map(method => ({
      id: method,
      label: method,
      isTicked: !!(selectedResearchMethods && selectedResearchMethods.includes(method)),
      readOnly: false,
    }));
  };

  const onChangeResearchMethod = (selectedMethod, isTicked) => {
    let selectedMethods = [];
    const currentMethods = selectedResearchMethods.slice(0);

    if (!isTicked) {
      // remove from list
      selectedMethods = currentMethods.filter(reason => {
        return reason !== selectedMethod;
      });
    } else {
      // add to list
      currentMethods.push(selectedMethod);
      selectedMethods = currentMethods.slice(0);
    }
    onChange(Q.SELECTED_RESEARCH_METHODS, selectedMethods);
  };

  return (
    <QuestionPage
      complete={props.complete}
      currentStep={props.currentStep}
      steps={props.steps}
      onNext={onNext}
      onBackToTaskList={onBackToTaskList}
      section={'Pre-CAS Questionnaire'}
    >
      <InputWithConfirm
        key={Q.CAMPUS}
        value={campus}
        label={'Which campus are you studying at?'}
        inputHelperText={props.pageConfig.Campus?.helpText}
        errorText={state.campusError}
        onChange={evt => onChange(Q.CAMPUS, evt.currentTarget.value)}
      />
      {considerOtherUni === true && (
        <>
          <SubHeading>Please list two other universities you researched as part of your UK study plans</SubHeading>

          <Button id="courseNotFound" onClick={() => onChange(Q.CONSIDER_OTHER_UNI, false)} mb={6}>
            I did not research other universities
          </Button>

          <AutocompleteInputWithConfirm
            id="select-university-1"
            key="select-university-1"
            label="Select University 1"
            onChange={evt => onUniversityChange(evt, 'university1Suggestions', Q.OTHER_UNI_1)}
            value={otherUni1}
            inputHelperText={props.pageConfig.ConsiderOtherUni?.helpText}
            showErrorText={!!state.otherUni1Error}
            errorText={state.otherUni1Error}
            suggestions={state.university1Suggestions}
            onBlur={evt => onBlurOtherUni(evt, Q.OTHER_UNI_1)}
            onFocus={evt => onFocusOtherUni(evt, 'otherUni1Error')}
          />

          <AutocompleteInputWithConfirm
            id="select-university-2"
            key="select-university-2"
            label="Select University 2"
            onChange={evt => onUniversityChange(evt, 'university2Suggestions', Q.OTHER_UNI_2)}
            value={otherUni2}
            inputHelperText={props.pageConfig.ConsiderOtherUni?.helpText}
            showErrorText={!!state.otherUni2Error}
            errorText={state.otherUni2Error}
            suggestions={state.university2Suggestions}
            onBlur={evt => onBlurOtherUni(evt, Q.OTHER_UNI_2)}
            onFocus={evt => onFocusOtherUni(evt, 'otherUni2Error')}
          />

          <CheckboxOptionsWithConfirm
            id="research-methods"
            key={Q.SELECTED_RESEARCH_METHODS}
            inputHelperText={props.pageConfig.UniResearchMethod?.helpText}
            errorText={state.researchMethodError}
            checkboxes={getResearchMethods()}
            labelText="How did you research these universities?"
            onChange={onChangeResearchMethod}
          />

          {selectedResearchMethods && selectedResearchMethods.findIndex(method => method === 'Other') > -1 && (
            <InputWithConfirm
              key={Q.SELECTED_RESEARCH_METHODS_OTHER}
              value={selectedResearchMethodsOther}
              errorText={state.selectedResearchMethodsOtherError}
              label={'Please provide more information'}
              onChange={evt => onChange(Q.SELECTED_RESEARCH_METHODS_OTHER, evt.currentTarget.value)}
            />
          )}
        </>
      )}
      {considerOtherUni === false && (
        <>
          <Button id="courseNotFound" onClick={() => onChange(Q.CONSIDER_OTHER_UNI, true)} mb={6}>
            I did research other universities
          </Button>

          <TextareaWithConfirm
            key={Q.WHY_NOT_OTHER_UNI}
            value={whyNotOtherUni}
            errorText={state.whyNotOtherUniError}
            label={'Please explain why you did no research on other universities while planning your overseas study'}
            inputHelperText={props.pageConfig.ConsiderOtherUniReason?.helpText}
            onChange={evt => onChange(Q.WHY_NOT_OTHER_UNI, evt.currentTarget.value)}
          />
        </>
      )}

      <RadioOptionsWithConfirm
        label="Did you consider any other course?"
        errorText={state.considerOtherCoursesError}
        questions={[
          {
            char: 'Y',
            label: 'Yes',
            selected: considerOtherCourses === true,
          },
          {
            char: 'N',
            label: 'No',
            selected: considerOtherCourses === false,
          },
        ]}
        isInline={true}
        onClick={question => onChange(Q.CONSIDER_OTHER_COURSES, question.label === 'Yes')}
      />

      {considerOtherCourses === true && (
        <InputWithConfirm
          key={Q.CONSIDER_OTHER_COURSE}
          value={considerOtherCourse}
          errorText={state.considerOtherCourseError}
          label={'What course did you consider?'}
          inputHelperText={props.pageConfig.ConisderOtherCourseName?.helpText}
          onChange={evt => onChange(Q.CONSIDER_OTHER_COURSE, evt.currentTarget.value)}
        />
      )}

      {considerOtherCourses === false && (
        <InputWithConfirm
          key={Q.WHY_NOT_CONSIDER_OTHER_COURSE}
          value={whyNotConsiderOtherCourse}
          errorText={state.whyNotConsiderOtherCourseError}
          label={'Why did you not consider other courses?'}
          inputHelperText={props.pageConfig.ConsiderOtherCourseReason?.helpText}
          onChange={evt => onChange(Q.WHY_NOT_CONSIDER_OTHER_COURSE, evt.currentTarget.value)}
        />
      )}

      <RadioOptionsWithConfirm
        label="Does your course align with your future career plans?"
        errorText={state.courseAlignFutureCareerError}
        questions={[
          {
            char: 'Y',
            label: 'Yes',
            selected: courseAlignFutureCareer === true,
          },
          {
            char: 'N',
            label: 'No',
            selected: courseAlignFutureCareer === false,
          },
        ]}
        isInline={true}
        onClick={question => onChange(Q.COURSE_ALIGN_FUTURE_CAREER, question.label === 'Yes')}
      />

      {courseAlignFutureCareer === false && (
        <InputWithConfirm
          key={Q.COURSE_ALIGN_FUTURE_CAREER_OTHER}
          value={courseAlignFutureCareerOther}
          errorText={state.courseAlignFutureCareerOtherError}
          label={'Please explain why'}
          inputHelperText={props.pageConfig.CourseAlignCareerReason?.helpText}
          onChange={evt => onChange(Q.COURSE_ALIGN_FUTURE_CAREER_OTHER, evt.currentTarget.value)}
        />
      )}
    </QuestionPage>
  );
};

export default InterviewQPage2;
